import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DialogConfirmSpaceEmailComponent } from '../dialog-confirm-space-email/dialog-confirm-space-email.component';
import { DataService } from 'src/app/core/services/data/data.service';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-dialog-update-parker-emailaddress',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    ReactiveFormsModule,
  ],
  templateUrl: './dialog-update-parker-emailaddress.component.html',
  styleUrl: './dialog-update-parker-emailaddress.component.scss',
})
export class DialogUpdateParkerEmailaddressComponent implements OnInit {
  parkerId: string;
  updateEmailForm = new FormGroup({
    emailAddress: new FormControl('', [Validators.required]),
  });

  //services:
  dataService = inject(DataService);
  appGeneralState = inject(AppGeneralStateService);
  destroyRefService = inject(DestroyRef);
  snackBar = inject(MatSnackBar);

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmSpaceEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IEmailAddressUpdate,
  ) {}

  ngOnInit(): void {}

  onSubmitUpdateEmailAddress(): void {
    const newEmailAddress: string = this.updateEmailForm.get('emailAddress').value;

    this.updateEmailAddress(this.data.parkerId, newEmailAddress);
  }

  updateEmailAddress(parkerId: string, emailAddress: string): void {
    this.dataService
      .UpdateLotParkingPrimaryEmail(parkerId, emailAddress)
      .pipe(takeUntilDestroyed(this.destroyRefService))
      .subscribe({
        next: (res) => {},
        error: (err: any) => {
          this.snackBar.open(
            'An unexpected error occurred and the Email Address has not been updated.  Please try again and if this continues please contact the administrator.',
            '',
            { duration: 5000 },
          );
        },
        complete: () => {
          this.dialogRef.close(emailAddress);
        },
      });
  }
}

export interface IEmailAddressUpdate {
  emailAddress: string;
  parkerId: string;
}
